import styled from 'styled-components';

export const Wrapper = styled.div`
    padding: 1rem;
    h4 {
        margin-bottom: 0;
    }
`;

export const FiltersWrapper = styled.div`
    display: inline-block;
    background: #f4f4f4;
    padding: 1rem;
    padding-bottom: 0;
    border: solid 1px #ddd;
    box-shadow: 0 2px 6px -1px #ddd;
    margin-bottom: 0.5rem;
`;

export const FilterRow = styled.div`
    display: flex;
    margin-bottom: 1rem;
`;

export const DateRangeFilterWrapper = styled.div`
    display: flex;
    align-items: center;

    input {
        padding: 0.5rem;
        margin: 0 1rem;
    }
`;

export const EmissionDescription = styled.p`
    font-style: italic;
    font-size: 0.8rem;
    color: #00447ee0;
    margin-bottom: 2rem;
`;

export const PortDateCol = styled.div`
    display: grid;
    grid-template-columns: 7rem 1fr;
`;

export const ReportActionsCell = styled.td`
    width: 5.5rem;
    min-width: 5.5rem;
    overflow: visible !important;
    text-overflow: clip !important;
    white-space: normal !important;
`;

export const ReportActions = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.25rem;
    min-width: 4.5rem;
`;

export const ReportActionButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1.75rem;
    height: 1.75rem;
    padding: 0.25rem;
    border: 0;
    border-radius: 0.2rem;
    background: transparent;
    color: #00447e;
    cursor: pointer;

    &:hover:not(:disabled) {
        background: #e1e9f3;
    }

    &:focus-visible {
        outline: 2px solid #00447e;
        outline-offset: 1px;
    }

    &:disabled {
        cursor: wait;
        opacity: 0.6;
    }
`;

export const VersionHistoryRegion = styled.div`
    flex-basis: 100%;
    width: 100%;
    overflow-wrap: anywhere;

    ol {
        margin: 0.25rem 0;
        padding-left: 1rem;
    }

    li {
        line-height: 1.5;

        button {
            vertical-align: middle;
        }
    }
`;

export const TableWrapper = styled.div`
    height: calc(100vh - 25rem);
    overflow: auto;

    .checkbox-col {
        width: 2rem;
    }
`;

export const PaginatorWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 1rem;

    button {
        margin: 0 0.5rem;
    }
`;
